
const cNav = () => {
  const menu = document.getElementById("menu"),
    menuClose = document.getElementById("menu_close"),
    menuOpen = document.getElementById("menu_open");
    

  menuOpen.onclick = () => {
    menu.hidden = false;
    document.body.style.overflowY = "hidden";
  };

  menuClose.onclick = () => {
    menu.hidden = true;
    document.body.style.overflowY = "inherit";
  };

};

export default cNav;